import { render } from "./ProvidersList.vue?vue&type=template&id=396b89c8"
import script from "./ProvidersList.vue?vue&type=script&lang=js"
export * from "./ProvidersList.vue?vue&type=script&lang=js"

import "./ProvidersList.vue?vue&type=style&index=0&id=396b89c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__